import Icon from '@mui/material/Icon'
import Dashboard from './dashboard'








import MarketplaceApps from './MarketplaceApps'
import UpdateRequests from './UpdateRequests'





import Changelogs from './Changelogs'
import UserInstalls from './UserInstalls'
import AppLogs from './AppLogs'



import AppTriggerModel from './AppTriggerModel'

import Roadmap from './RoadMap'
import RoadmapCompany from './RoadmapCompany'

import Newsfeeds from './Newsfeeds'
import Staff from './Staff'
import { useUserInfo } from 'context/user'



function useRoutes() {
  const [user] = useUserInfo()
  console.log('user', user)

  const allRoutes = [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },
    {
      type: 'collapse',
      name: 'Newsfeeds',
      key: 'newsfeeds',
      icon: <Icon fontSize="small">article</Icon>,
      route: '/newsfeeds',
      component: <Newsfeeds />,
    },
    {
      type: 'collapse',
      name: 'Changelogs',
      key: 'changelogs',
      icon: <Icon fontSize="small">history</Icon>,
      route: '/changelogs',
      component: <Changelogs />,
    },

    {
      type: 'collapse',
      name: 'User Installs',
      key: 'users',
      icon: <Icon fontSize="small">install_mobile</Icon>,
      route: '/user_installs',
      component: <UserInstalls />,
    },
    {
      type: 'collapse',
      name: 'app_logs',
      key: 'app_logs',
      icon: <Icon fontSize="small">app_logs</Icon>,
      route: '/app_logs',
      component: <AppLogs />,
    },
    {
      type: 'collapse',
      name: 'Roadmap',
      key: 'roadmap',
      icon: <Icon fontSize="small">timeline</Icon>,
      route: '/roadmap/*',
      collapse: [
        {
          type: 'collapse',
          name: 'Roadmap',
          key: 'roadmap',
          icon: <Icon fontSize="small">map</Icon>,
          route: '/roadmap',
          component: <Roadmap />,
        },
        {
          type: 'collapse',
          name: 'Roadmap Details',
          key: 'roadmap_details',
          icon: <Icon fontSize="small">details</Icon>,
          route: '/roadmap_details',
          component: <RoadmapCompany />,
        },
      ],
    },
    {
      type: 'collapse',
      name: 'Marketplace',
      key: 'marketplace_apps',
      icon: <Icon fontSize="small">store</Icon>,
      route: '/marketplace_apps/*',
      collapse: [
        {
          type: 'collapse',
          name: 'Marketplace Apps',
          key: 'marketplace_apps',
          icon: <Icon fontSize="small">apps</Icon>,
          route: '/marketplace_apps/*',
          component: <MarketplaceApps />,
        },
        {
          type: 'collapse',
          name: 'App Trigger Model',
          key: 'app_trigger_model',
          icon: <Icon fontSize="small">bolt</Icon>,
          route: '/app_trigger_model/*',
          component: <AppTriggerModel />,
        },
        {
          type: 'collapse',
          name: 'App Requests',
          key: 'update_requests',
          icon: <Icon fontSize="small">markunread</Icon>,
          route: '/update_requests',
          component: <UpdateRequests />,
        },
      ],
    },

    {
      type: 'collapse',
      name: 'Staff',
      key: 'staff',
      icon: <Icon fontSize="small">people</Icon>,
      route: '/staff',
      component: <Staff />,
    },


  ];

  // Only allow "superadmin" and "manager" to see all routes
  const allowedRoles = ['superadmin', 'manager']

  if (user?.roles?.some((role) => allowedRoles.includes(role))) {
    return allRoutes // Full access for superadmin/manager
  }

  if (user?.roles?.some((role) => role === 'onboarding_admin')) {
    const allowedKeys = new Set([
      'changelogs', // Changelogs
      'newsfeeds', // News feed
      'players', // Players (+ sub-routes)
      'partner', // Partners
      'medialibrary', // Media library (+ sub-routes)
      'awardgroup', // Award Ranking (+ sub-routes)
      'banners', // Banners (unique key)
      'tooltip', // ToolTip (unique key)
      'checklist', // Check list (+ sub-routes)
      'questions', // Questions (+ sub-routes)
      'faq', // FAQs (+ sub-routes)
      'knowledgebase', // Knowledge Base (+ sub-routes)
      'onboardcategory', // Onboard list (+ sub-routes)
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'client')) {
    const allowedKeys = new Set([
      'partner',
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }
  if (user?.roles?.some((role) => role === 'bid_data')) {
    const allowedKeys = new Set([
      'partner', // Partners
      'partnersaas',
    ])

    return allRoutes.filter((route) => allowedKeys.has(route.key))
  }

  // Fallback for non-admin users (e.g., regular users)
  return [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },

  ]
}

export default useRoutes
